export default "__VITE_ASSET__BeOQ128X__"